'use client';

import { useServerInsertedHTML } from 'next/navigation';
import type React from 'react';
import { useState } from 'react';
import { ServerStyleSheet, StyleSheetManager } from 'styled-components';

/**
 * StyledComponentsRegistry
 *
 * This component handles the server-side rendering of styled-components
 * in Next.js App Router. It collects all styles during server rendering
 * and injects them into the HTML head.
 *
 * Usage: Wrap your root layout children with this component
 */
export default function StyledComponentsRegistry({ children }: { children: React.ReactNode }) {
  // Only create stylesheet once with lazy initial state
  // x]ates on the server side but on the client
  const [styledComponentsStyleSheet] = useState(() => new ServerStyleSheet());

  useServerInsertedHTML(() => {
    const styles = styledComponentsStyleSheet.getStyleElement();
    styledComponentsStyleSheet.instance.clearTag();
    return <>{styles}</>;
  });

  // On the client, just render children directly
  if (typeof window !== 'undefined') {
    return <>{children}</>;
  }

  // On the server, wrap with StyleSheetManager to collect styles
  return (
    <StyleSheetManager sheet={styledComponentsStyleSheet.instance}>{children}</StyleSheetManager>
  );
}
